// extracted by mini-css-extract-plugin
export default {"headerBar":"OJ-z","pointsSection":"PJ-z","goToDashboard":"QJ-z"};